<template>
  <li qaid="project-one-bike-selection-card" class="project-one-bike-selection-card relative">
    <pdl-label
      v-if="isSelected"
      kind="prominent"
      class="absolute -top-4 -left-2 z-10"
      qaid="project-one-selected-bike-label"
      v-html="bp('currentSelection')"
    />

    <pdl-card
      :is-padded="isSelected"
      :class="isSelected && 'shadow-lg'"
      qaid="project-one-bike-selection-card-pdl-card"
    >
      <responsive-image
        slot="image"
        qaid="bike-selection-card__img"
        class="bike-selection-card__img"
        :src="bike.imageUrl"
        sizes="(max-width: 640) 100vw, (max-width: 1024) 50vw, 33vw"
        :alt="bike.modelName"
      />
      <template slot="bodyContent">
        <h2
          qaid="bike-selection-card__title"
          class="bike-selection-card__title heading heading--md mb-1"
          v-html="bike.modelName"
        />

        <p
          v-if="b2b && !consumerFriendlyMode && !isHidingPrices"
          qaid="bike-selection-card__msrp"
          class="bike-selection-card__msrp text-md text-gray-60"
          v-html="bp('cardStartingAt', bike.defaultDealerCost)"
        />
        <p
          v-else-if="!isHidingPrices"
          qaid="bike-selection-card__msrp"
          class="bike-selection-card__msrp text-md text-gray-60"
          v-html="bp('cardStartingAt', bike.defaultAdvertised)"
        />

        <trek-button
          qaid="bike-selection-card__button"
          small
          class="bike-selection-card__button mt-3"
          primary
          @click="selectBike(bike.id)"
        >
          <span v-html="bp('cardBuild')" />
        </trek-button>

        <span
          qaid="bike-selection-card__separator"
          class="bike-selection-card__separator border-b border-gray-10 block my-3 w-full"
        />

        <div>
          <h3
            qaid="bike-selection-card__drivetrain-title"
            class="bike-selection-card__drivetrain-title text-xs text-gray-60 mb-25"
            v-html="bp('cardDrivetrain')"
          />

          <p
            qaid="bike-selection-card__drivetrain"
            class="bike-selection-card__drivetrain text-md"
            v-html="bike.defaultGruppo"
          />
        </div>
      </template>
    </pdl-card>
  </li>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {PdlCard} from '@pedal/pdl-card';
import {PdlLabel} from '@pedal/pdl-label';
import TrekButton from '@/components/TrekButton';
import ResponsiveImage from '@/components/ResponsiveImage';

export default {
  components: {PdlCard, PdlLabel, TrekButton, ResponsiveImage},

  props: {
    bike: {
      type: Object,
      required: true,
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      buildId: null,
    };
  },

  computed: {
    ...mapState('backend', ['b2b', 'consumerFriendlyMode']),
    ...mapState('projectOne', ['isHidingPrices']),
  },

  created() {
    this.buildId = this.$route.params.buildId;
  },

  methods: {
    async selectBike(bikeId) {
      if (bikeId === this.buildId) {
        this.$router.push({name: 'paintTheme', params: {buildId: bikeId}});
      } else {
        this.clearCachedSelections();
        this.setIsThemeSelected(false);
        this.setPageLoading(true);
        const response = await this.fetchBikePackage(bikeId);
        if (response === 200) this.$router.push({name: 'paintTheme', params: {buildId: bikeId}});
      }
    },

    ...mapActions('projectOne', ['fetchBikePackage']),
    ...mapMutations('projectOne', ['setPageLoading', 'clearCachedSelections', 'setIsThemeSelected']),
  },
};
</script>
